import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tab-teach"
};
var _hoisted_2 = {
  class: "left"
};
var _hoisted_3 = {
  class: "right"
};
import { watch, inject, ref, reactive, computed, onMounted } from 'vue';
import { exportClassTeacherData, exportPrincipalData, exportTeacherData,
// getGradeDirector,
// getGradeRecotor,
getGroupTeacher, getSchoolOrGrade, getStudentTeacher, getSubjectDirector, getSubjectRecotor } from '@/api/index-guan';
import FormItem from './lib/FormItem';
import Switch from './lib/Switch';
import { dateFormat, getRandomString } from '@/utils';
export default {
  __name: 'teachTab',
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    gradeId: {
      type: String,
      default: ''
    },
    classId: {
      type: String,
      default: ''
    },
    cycle: {
      type: String,
      default: ''
    },
    schoolName: {
      type: String,
      default: ''
    },
    outGradeName: {
      type: String,
      default: ''
    },
    outClassTypeName: {
      type: String,
      default: ''
    },
    outClassName: {
      type: String,
      default: ''
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    cycleType: {
      type: [String, Number],
      default: '1'
    }
  },
  emits: ['changeTab'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var active = inject('activeName', 'rector');
    var groupOptions = ref([]);
    var studentOptions = ref([]);
    var states = reactive({
      classType: 3,
      grade: '',
      subject: '',
      isUse: false,
      groupId: '',
      studentId: ''
    });
    var classTypeOptions = [{
      label: '行政班',
      value: 3
    }, {
      label: '教学班',
      value: 4
    }];
    var gradeOptions = ref([]);
    var subjectOptions = ref([]);
    var handleChange = function handleChange() {
      emits('changeTab', states);
    };
    var ownerClassTypeName = computed(function () {
      var _classTypeOptions$fin;
      return ((_classTypeOptions$fin = classTypeOptions.find(function (item) {
        return item.value === states.classType;
      })) === null || _classTypeOptions$fin === void 0 ? void 0 : _classTypeOptions$fin.label) || '';
    });
    var ownerGradeName = computed(function () {
      var _gradeOptions$value$f;
      return ((_gradeOptions$value$f = gradeOptions.value.find(function (item) {
        return item.id === states.grade;
      })) === null || _gradeOptions$value$f === void 0 ? void 0 : _gradeOptions$value$f.name) || '';
    });
    var ownerSubjectName = computed(function () {
      var _subjectOptions$value;
      return ((_subjectOptions$value = subjectOptions.value.find(function (item) {
        return item.value === states.subject;
      })) === null || _subjectOptions$value === void 0 ? void 0 : _subjectOptions$value.name) || '';
    });
    var ownerGroupName = computed(function () {
      var _groupOptions$value$f;
      return ((_groupOptions$value$f = groupOptions.value.find(function (item) {
        return item.value === states.groupId;
      })) === null || _groupOptions$value$f === void 0 ? void 0 : _groupOptions$value$f.name) || '';
    });
    var ownerStudentName = computed(function () {
      var _studentOptions$value;
      return ((_studentOptions$value = studentOptions.value.find(function (item) {
        return item.value === states.studentId;
      })) === null || _studentOptions$value === void 0 ? void 0 : _studentOptions$value.name) || '';
    });
    var getSubjectDatas = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var subjectParam;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              subjectParam = {
                schoolId: props.schoolId,
                gradeId: states.grade,
                cycleType: props.cycleType
              };
              if (active.value === 'rector') {
                // 学科下拉框-校长
                getSubjectRecotor(subjectParam).then(function (res) {
                  subjectOptions.value = res.data.data;
                  if (subjectOptions.value.length > 0) {
                    states.subject = subjectOptions.value[0].value;
                  }
                });
              } else if (active.value === 'director') {
                subjectParam.gradeId = props.gradeId;
                getSubjectDirector(subjectParam).then(function (res) {
                  subjectOptions.value = res.data.data;
                  if (subjectOptions.value.length > 0) {
                    states.subject = subjectOptions.value[0].value;
                  }
                });
              }
              emits('changeTab', states);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getSubjectDatas() {
        return _ref2.apply(this, arguments);
      };
    }();
    var getGroupTeacherData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              data = {
                classId: props.classId
              };
              _context2.n = 1;
              return getGroupTeacher(data).then(function (res) {
                groupOptions.value = res.data.data;
                if (groupOptions.value.length > 0) {
                  states.groupId = groupOptions.value[0].value;
                } else {
                  states.groupId = '';
                }
              });
            case 1:
              getStudentDatasByGroup();
              emits('changeTab', states);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getGroupTeacherData() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getStudentDatasByGroup = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var studentData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(states.groupId && props.classId)) {
                _context3.n = 2;
                break;
              }
              studentData = {
                groupId: states.groupId,
                classId: props.classId
              };
              _context3.n = 1;
              return getStudentTeacher(studentData).then(function (res) {
                studentOptions.value = res.data.data;
                var allData = {
                  name: '全部',
                  value: ''
                };
                studentOptions.value.unshift(allData);
                states.studentId = '';
              });
            case 1:
              _context3.n = 3;
              break;
            case 2:
              studentOptions.value = [];
              states.studentId = '';
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function getStudentDatasByGroup() {
        return _ref4.apply(this, arguments);
      };
    }();
    // 修改年级
    var handleChangeGrade = function handleChangeGrade() {
      getSubjectDatas();
    };
    // 修改小组，查询学生
    var handleChangeGroup = function handleChangeGroup() {
      getStudentDatasByGroup();
      handleChange();
    };
    // 获取初始化时基本收据
    var getDefaultSearchData = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var gradeParam;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              gradeParam = {
                deptId: props.schoolId,
                type: 1,
                userId: props.userId
              };
              if (!(active.value === 'rector' && props.schoolId)) {
                _context4.n = 1;
                break;
              }
              _context4.n = 1;
              return getSchoolOrGrade(gradeParam).then(function (res) {
                gradeOptions.value = res.data.data;
              });
            case 1:
              if (gradeOptions.value.length > 0) {
                states.grade = gradeOptions.value[0].id;
              }
              // 获取校长， 年级主任时的学科类数据
              getSubjectDatas();
              // 教师: 获取小组，学生的数据
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function getDefaultSearchData() {
        return _ref5.apply(this, arguments);
      };
    }();
    // eslint-disable-next-line complexity
    var exportExcle = function exportExcle(data) {
      var blob = new Blob([data], {
        type: 'application/vnd.ms-excel'
      });
      var objectUrl = URL.createObjectURL(blob);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = objectUrl;
      var formatType = 'yyyy/MM/dd';
      var time = dateFormat(new Date(), formatType);
      var randomNum = getRandomString(2);
      var names = '';
      if (active.value === 'rector') {
        names = "".concat(props.schoolName).concat(props.schoolName ? '-' : '').concat(props.cycle).concat(props.cycle ? '-' : '').concat(ownerClassTypeName.value).concat(ownerClassTypeName.value ? '-' : '');
        names += "".concat(ownerGradeName.value).concat(ownerGradeName.value ? '-' : '').concat(ownerSubjectName.value).concat(props.ownerSubjectName ? '-' : '');
      } else if (active.value === 'director') {
        names = "".concat(props.schoolName).concat(props.schoolName ? '-' : '').concat(props.cycle).concat(props.cycle ? '-' : '').concat(ownerClassTypeName.value).concat(ownerClassTypeName.value ? '-' : '');
        names += "".concat(props.outGradeName).concat(props.outGradeName ? '-' : '').concat(ownerSubjectName.value).concat(props.ownerSubjectName ? '-' : '');
      } else if (active.value === 'teacher') {
        names = "".concat(props.outClassTypeName).concat(props.outClassTypeName ? '-' : '').concat(props.outClassName).concat(props.outClassName ? '-' : '').concat(props.cycle).concat(props.cycle ? '-' : '');
        names += "".concat(ownerGroupName.value).concat(ownerGroupName.value ? '-' : '').concat(ownerStudentName.value).concat(ownerStudentName.value ? '-' : '');
      }
      a.download = "".concat(names, "\u8BFE\u5802\u4E92\u52A8\u6570\u636E-").concat(time, "-").concat(randomNum, ".xlsx");
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    };
    var handleExport = function handleExport() {
      if (active.value === 'rector') {
        exportPrincipalData({
          schoolId: props.schoolId,
          classType: states.classType,
          subject: states.subject,
          isUse: states.isUse ? 1 : 0,
          cycle: props.cycle,
          grade: states.grade,
          cycleType: props.cycleType
        }).then(function (res) {
          exportExcle(res.data);
        });
      } else if (active.value === 'director') {
        exportClassTeacherData({
          schoolId: props.schoolId,
          classType: states.classType,
          subject: states.subject,
          isUse: states.isUse ? 1 : 0,
          grade: props.gradeId,
          cycle: props.cycle,
          cycleType: props.cycleType
        }).then(function (res) {
          exportExcle(res.data);
        });
      } else if (active.value === 'teacher') {
        exportTeacherData({
          schoolId: props.schoolId,
          cycle: props.cycle,
          classRoom: props.classId,
          groupId: states.groupId,
          studentId: states.studentId
        }).then(function (res) {
          exportExcle(res.data);
        });
      }
    };
    watch(function () {
      return props.schoolId;
    }, function (newVal) {
      if (newVal) {
        getDefaultSearchData();
      }
    });
    watch(function () {
      return props.gradeId;
    }, function (newVal) {
      if (newVal) {
        getSubjectDatas();
      }
    });
    watch(function () {
      return props.cycleType;
    }, function (newVal) {
      getSubjectDatas();
    });
    watch(function () {
      return props.classId;
    }, function (newVal) {
      // getSubjectDatas()
      // 获取小组和学生数据
      getGroupTeacherData();
    });
    onMounted(function () {
      if (props.schoolId) {
        getDefaultSearchData();
      }
      if (active.value === 'teacher' && props.classId) {
        getGroupTeacherData();
      }
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        size: "28",
        name: "teacher-detail"
      }), _createElementVNode("span", null, [_renderSlot(_ctx.$slots, "title", {}, function () {
        return [_cache[6] || (_cache[6] = _createTextVNode("教师授课详情", -1))];
      })])]), _createElementVNode("div", _hoisted_3, [_unref(active) !== 'teacher' ? (_openBlock(), _createBlock(_unref(FormItem), {
        key: 0
      }, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode("数据切换", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_unref(Switch), {
            modelValue: states.isUse,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return states.isUse = $event;
            }),
            onChange: handleChange
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _unref(active) !== 'teacher' ? (_openBlock(), _createBlock(_unref(FormItem), {
        key: 1
      }, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode("班级类型", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: states.classType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return states.classType = $event;
            }),
            options: classTypeOptions,
            onChange: handleChange
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _unref(active) === 'rector' ? (_openBlock(), _createBlock(_unref(FormItem), {
        key: 2
      }, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[9] || (_cache[9] = [_createTextVNode("年级", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: states.grade,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return states.grade = $event;
            }),
            keys: {
              label: 'name',
              value: 'id'
            },
            options: gradeOptions.value,
            onChange: handleChangeGrade
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _unref(active) !== 'teacher' ? (_openBlock(), _createBlock(_unref(FormItem), {
        key: 3
      }, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[10] || (_cache[10] = [_createTextVNode("学科", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: states.subject,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return states.subject = $event;
            }),
            keys: {
              label: 'name',
              value: 'value'
            },
            options: subjectOptions.value,
            onChange: handleChange
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _unref(active) === 'teacher' ? (_openBlock(), _createBlock(_unref(FormItem), {
        key: 4
      }, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[11] || (_cache[11] = [_createTextVNode("小组", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: states.groupId,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return states.groupId = $event;
            }),
            options: groupOptions.value,
            keys: {
              label: 'name',
              value: 'value'
            },
            onChange: handleChangeGroup
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _unref(active) === 'teacher' ? (_openBlock(), _createBlock(_unref(FormItem), {
        key: 5
      }, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[12] || (_cache[12] = [_createTextVNode("学生", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: states.studentId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return states.studentId = $event;
            }),
            options: studentOptions.value,
            keys: {
              label: 'name',
              value: 'value'
            },
            onChange: handleChange
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(FormItem), null, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[13] || (_cache[13] = [_createTextVNode(" ", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_button, {
            onClick: handleExport
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[14] || (_cache[14] = [_createTextVNode("导出全部", -1)]));
            }),
            _: 1
          })];
        }),
        _: 1
      })])]);
    };
  }
};